import React from 'react'
import Svg from '../../../component/Svg'
import { Link } from 'react-router-dom'

export default function AuthHeader() {
    return (
        <>
            <div className='roi-header-transparent'>
                <div className="container">
                    <div className="header-wrapper">
                        <Link to="" className="logo">
                            <Svg name="logo" />
                        </Link>

                    </div>
                </div>
            </div>
        </>
    )
}
